<!-- Divider -->
<div
  class="ui-horizontal-navigation-item-wrapper divider"
  [ngClass]="item.classes?.wrapper"
></div>
